export default {"src":"/_next/static/media/product.eed2c688.svg","height":15,"width":15};